// 数据统计「较昨日」趋势百分比格式化。
// prev 缺失或 ≤0 → '— 较昨日'(避免除零);相等 → '持平';否则 ↑/↓ X.X%。
export type TrendDir = 'up' | 'down' | 'flat' | 'none'

export function formatPctTrend(
  todayVal: number,
  prevVal: number | undefined,
): { dir: TrendDir; text: string } {
  if (prevVal === undefined || prevVal <= 0) return { dir: 'none', text: '— 较昨日' }
  if (todayVal === prevVal) return { dir: 'flat', text: '持平 较昨日' }
  const pct = ((todayVal - prevVal) / prevVal) * 100
  const up = pct > 0
  return {
    dir: up ? 'up' : 'down',
    text: `${up ? '↑' : '↓'}${Math.abs(pct).toFixed(1)}% 较昨日`,
  }
}
